import axios from "axios";

const API_URL = "https://api.forestia-group.com/resellers";

let Api = axios.create({
  baseURL: API_URL,
  headers: {
    Authorization: `Bearer M5Tu0h3JHQGj95VlrqJ+6J5EoSeXRWU46ano0lKzCZ8=`,
  },
});

const urlParams = new URLSearchParams(window.location.search);

Api.interceptors.request.use((config) => {
  config.params = config.params ? config.params : {};
  config.params["brands"] = urlParams.getAll("brands[]");
  config.params["lang"] = urlParams.get("lang");
  config.params["site"] = urlParams.get("site");
  return config;
});

export default Api;
